module.exports = __webpack_public_path__ + "static/media/404.d2d4dda1.png";